import { useToast } from "@/components/ui/use-toast";
import { useMutationWithErrorHandling } from "@/hooks/useMutationWithErrorHandling";
import { EmailTypeService } from "@/services/emailType";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

export const useUpdateEmailTypeMutation = (emailTypeId: string) => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const queryClient = useQueryClient();

  return useMutationWithErrorHandling({
    mutationFn: (description: string | null) =>
      EmailTypeService.updateType(emailTypeId, { description }),
    errorTitle: t("emailTypes.errors.update"),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["emailType", emailTypeId] }),
        queryClient.invalidateQueries({ queryKey: ["emailTypes"] }),
      ]);
      toast({ title: t("emailTypes.success.update") });
    },
  });
};
